import { GLAccountType } from "@app/constants/GLAccountType";

export class AccountType {
  id: string = "";
  code: string = "";
  name: string = "";
  productId:string = ""; //TODO to be edited
  type: string = "";
  parent: boolean = false;
  parentAccountId: any = "";
  enabled: boolean = true;
  balanceType:string = "";
  glAccountType: GLAccountType | string;
  manualEntriesAllowed: boolean = true;
  subAccounts?: AccountType[];
  parentCode? : string;
  parentName? : string;

  maxBalance?: number;
  minBalance?: number;
  quantifiable?: boolean;

}